(function () {
  "use strict";
  var root = document.getElementById("kpsl");
  if (!root || root.dataset.booted) return;
  root.dataset.booted = "1";

  var CFG = {
    /* This project's own API. Set window.KPSL_CONFIG = { api: "..." } before
       the block to point it somewhere else (a preview deployment, a local dev
       server). */
    api: "https://kp-store-locator-app.vercel.app/api/stores",
    /* "kp"       shops confirmed to carry King Palm — the default, and since
     *            the ProMap merge it covers ~21k locations rather than 687
     * "verified" every retailer we hold, which is a "smoke shops near you"
     *            list rather than a stock check */
    scope: "kp",
    fallback: { lat: 34.0522, lng: -118.2437, label: "Los Angeles, CA" },

    /* Street View as the storefront shot, and it is FREE.
     *
     * Google: "All Maps Embed API requests are available at no charge with
     * unlimited usage." So an embedded panorama costs nothing, where the Street
     * View Static image and a Places photo both bill $7 per 1,000 RENDERS.
     *
     * It is also the better picture for this job. A Places photo is
     * user-submitted and might be a menu board, a car park or somebody's lunch
     * — the entire reason the vision pass had to exist. Street View is always
     * the building, always framed the same, and exists for essentially every US
     * street address. Being able to look up and down the street is a genuine
     * improvement for someone deciding whether they can find the place.
     *
     * That leaves Places photos doing only the thing Street View cannot: the
     * inside of the shop, where King Palm is on a shelf. Which is the only
     * photo worth paying for.
     *
     * THE KEY IS PUBLIC. It ships in the page source, so it MUST be a separate
     * browser key restricted by HTTP referrer to kingpalm.com, with only Maps
     * Embed API enabled. Never the server-side Places key, which is billable
     * and unrestricted. */
    streetViewKey: "AIzaSyDaVJSC4tyX2qevlTKaBzL4TbhwmbP3sjo"
  };
  if (window.KPSL_CONFIG) for (var k in window.KPSL_CONFIG) CFG[k] = window.KPSL_CONFIG[k];
  /* Scheme + host of the API, for turning the root-relative photo paths it
     returns into absolute URLs.
     Resolved with URL() rather than a regex on CFG.api: a regex only matches an
     absolute base, so a relative one (a local dev server, a fixture path) fell
     through unchanged and produced "/mock" + "/mock/x.svg". */
  var API_ORIGIN = (function () {
    try { return new URL(CFG.api, window.location.href).origin; }
    catch (e) { return ""; }
  })();

  var $ = function (s) { return root.querySelector(s); };
  var form = $("[data-form]"), input = $('[name="q"]'), radius = $('[name="radius"]');
  var btn = $("[data-submit]"), near = $("[data-near]"), list = $("[data-list]"), count = $("[data-count]");
  var mapEl = $("[data-map]"), detail = $("[data-detail]"), dbody = $("[data-dbody]");
  var gal = $("[data-gal]"), photoEl = $("[data-photo]"), noimg = $("[data-noimg]");
  var backBtn = $("[data-back]");
  var shelf = $("[data-shelf]"), credit = $("[data-credit]"), dots = $("[data-dots]");
  var sv = $("[data-sv]");

  var map = null, markers = [], shops = [], selected = -1;
  var photos = [], pi = 0, detailReq = 0, currentName = "";

  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };

  /* ---- map ------------------------------------------------------------- */

  function initMap(lat, lng, zoom) {
    if (map) return;
    map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true }).setView([lat, lng], zoom || 10);
    L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", {
      attribution: "&copy; OpenStreetMap &copy; CARTO", maxZoom: 19, subdomains: "abcd",
    }).addTo(map);
    /* Wheel zoom off until the map is clicked, so a trackpad scroll past the
       section does not trap the page inside it. */
    map.on("click", function () { map.scrollWheelZoom.enable(); });

    /* Leaflet caches the container size and only fetches tiles to cover it.
       Anything that changes that size after init — webfonts landing, the
       results rail growing, a theme header collapsing on scroll, a device
       frame resizing — leaves the newly exposed area as bare background. It
       showed up here as a black band across the top of the map, with 10 tiles
       rendered where ~24 were needed.
       One invalidateSize() call cannot cover all of those, so watch the
       element instead of guessing when it settles. */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        clearTimeout(map.__kpslResize);
        map.__kpslResize = setTimeout(function () { map.invalidateSize({ pan: false }); }, 80);
      });
      ro.observe(mapEl);
    } else {
      /* No ResizeObserver: at least catch webfonts arriving after first paint. */
      setTimeout(function () { map.invalidateSize({ pan: false }); }, 400);
    }
  }

  /* The King Palm crown. Gold means a confirmed King Palm stockist, silver a
     retailer we hold but have not confirmed stock for — so the colour carries
     the same distinction the list's gold dot does, and neither is the only
     place a shopper can read it.

     The crown is the BRAND mark, drawn in ink on the gold teardrop rather than
     in its own black. A black crown on a black map is invisible — the gold pin
     body is what makes it findable, and the mark reads as the logo because it
     is dark-on-light exactly as the logo is.

     Drawn once as a string and reused; a divIcon is re-created on every
     selection change and building the SVG each time is wasted work. */
  var CROWN =
    '<svg viewBox="0 0 32 42" width="32" height="42" aria-hidden="true" focusable="false">'
    + '<path d="M16 0C7.2 0 0 7.2 0 16c0 11.4 16 26 16 26s16-14.6 16-26C32 7.2 24.8 0 16 0z" fill="{BG}"/>'
    + '<g fill="{FG}">'
    /* body: three peaks, concave valleys between them, flat base */
    + '<path d="M9.5 12.9 L8.9 20.9 L23.1 20.9 L22.5 12.9'
      + 'C21.6 18.2 18.6 18.6 16 11.0'
      + 'C13.4 18.6 10.4 18.2 9.5 12.9 Z"/>'
    /* the three finials */
    + '<circle cx="16" cy="9.6" r="1.55"/>'
    + '<circle cx="9.2" cy="11.9" r="1.25"/>'
    + '<circle cx="22.8" cy="11.9" r="1.25"/>'
    /* base band, arced the way the logo's is — centre higher than the ends */
    + '<path d="M9.3 22.3 Q16 21.3 22.7 22.3 L22.7 23.9 Q16 22.9 9.3 23.9 Z"/>'
    + "</g></svg>";

  function pin(i, active, stocks) {
    /* Selected is CREAM, not a brighter gold. It was #E0AC3C against a
       #C59227 default -- two golds one step apart, which on a dark map at 32px
       is not a state change, it is the same pin. Brandon clicked list rows and
       could not tell which pin he had picked, and he was right: the only real
       signals were the size bump and a glow. Cream is the one value in this
       palette that reads instantly against both the gold and the silver. */
    var bg = active ? "#F4EFE4" : stocks ? "#C59227" : "#B8BCC4";
    return L.divIcon({
      className: "",
      html: '<div class="kpsl-pin' + (active ? " kpsl-pin--on" : "") + '">'
          + CROWN.replace("{BG}", bg).replace("{FG}", "#0A0A0B") + "</div>",
      iconSize: active ? [38, 50] : [32, 42],
      iconAnchor: active ? [19, 50] : [16, 42],
    });
  }

  /* "3560 Central Ave" / "Riverside, CA 92506" — two lines, the way an address
     is actually written. */
  function cityLine(s) {
    var tail = [[s.city, s.state].filter(Boolean).join(", "), s.zip].filter(Boolean).join(" ");
    return [s.address, tail].filter(Boolean);
  }

  /* The shop's Google listing — photos, reviews, hours, the lot.
   *
   * Free, and free in the strong sense: this is a hyperlink, not an API call.
   * No key, no place_id, no enrichment needed first, so it works for all 24,549
   * stores on day one rather than only the ones someone has already opened.
   *
   * query_place_id is used when we happen to hold one (it pins the result
   * exactly), but the name+address form resolves fine without it — which is the
   * whole point. Google renders the photos on their own page, under their own
   * terms, and we pay nothing to send someone there. */
  function googleListing(s, placeId) {
    var q = [s.name, s.address, s.city, s.state, s.zip].filter(Boolean).join(", ");
    return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(q)
      + (placeId ? "&query_place_id=" + encodeURIComponent(placeId) : "");
  }

  function directions(s) {
    var q = [s.name, s.address, s.city, s.state, s.zip].filter(Boolean).join(", ");
    return "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent(q);
  }

  /* ---- list ------------------------------------------------------------ */

  function render(data) {
    shops = data.stores || [];
    closeDetail();
    count.textContent = shops.length
      ? shops.length + (shops.length === 1 ? " location" : " locations") + " within " + data.radius + " miles"
      : "";

    if (!shops.length) {
      list.innerHTML = '<p class="kpsl-msg">No King Palm stockists there yet. Try a wider radius, '
        + 'or <a href="/collections/all" style="color:#C59227">shop online</a>.</p>';
      clearMarkers();
      return;
    }

    var html = "";
    shops.forEach(function (s, i) {
      html += '<button class="kpsl-card" type="button" data-i="' + i + '">'
        + '<p class="kpsl-status">' + (s.stocksKingPalm
            ? '<i class="kpsl-dot" aria-hidden="true"></i>Stocks King Palm'
            : "Retailer")
        + "</p>"
        + '<p class="kpsl-cname">' + esc(s.name || "Store") + "</p>"
        + '<p class="kpsl-caddr">' + cityLine(s).map(esc).join("<br>") + "</p>"
        + '<p class="kpsl-cmeta">'
        + (s.miles != null ? '<span class="kpsl-cmiles">' + s.miles + " mi</span>" : "")
        + (s.phone ? "<span>" + esc(s.phone) + "</span>" : "")
        + "</p></button>";
    });
    list.innerHTML = html;

    var c = data.center || { lat: shops[0].lat, lng: shops[0].lng };
    initMap(c.lat, c.lng);
    clearMarkers();
    shops.forEach(function (s, i) {
      var m = L.marker([s.lat, s.lng], { icon: pin(i, false, s.stocksKingPalm), keyboard: false }).addTo(map);
      m.on("click", function () { select(i, true); });
      markers.push(m);
    });
    /* The observer above is debounced, and fitBounds against a stale size picks
       the wrong zoom — so size it synchronously right before fitting. */
    map.invalidateSize({ pan: false });
    map.fitBounds(L.latLngBounds(shops.map(function (s) { return [s.lat, s.lng]; })).pad(0.18), { maxZoom: 14 });
  }

  function clearMarkers() {
    if (!map) return;
    markers.forEach(function (m) { map.removeLayer(m); });
    markers = [];
  }

  /* ---- selection ------------------------------------------------------- */

  function select(i, fromMap) {
    if (selected === i && detail.dataset.open === "1") return;
    var s = shops[i];
    if (markers[selected]) markers[selected].setIcon(pin(selected, false, shops[selected] && shops[selected].stocksKingPalm));
    selected = i;
    if (markers[i]) {
      markers[i].setIcon(pin(i, true, s && s.stocksKingPalm));
      map.setView(markers[i].getLatLng(), Math.max(map.getZoom(), 13), { animate: true });
      /* Immediately, from the list row we already have. The detail fetch calls
         this again with photos when it lands; waiting for that round trip is
         what made clicking a row feel like nothing had happened. */
      pinPreview([], s);
    }
    [].forEach.call(list.children, function (c) { c.removeAttribute("aria-current"); });
    var card = list.querySelector('[data-i="' + i + '"]');
    if (card) {
      card.setAttribute("aria-current", "true");
      if (fromMap) card.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
    openDetail(shops[i]);
  }

  /* ---- detail panel ---------------------------------------------------- */

  function openDetail(s) {
    if (!s) return;
    var req = ++detailReq;
    currentName = s.name || "";
    detail.dataset.open = "1";
    detail.setAttribute("aria-hidden", "false");
    /* Without this the panel opens and the keyboard stays behind it on the
       list — tab lands on the next store rather than on anything in the thing
       that just appeared. */
    setTimeout(function () { backBtn.focus(); }, 0);
    setPhotos([], s);

    /* The design puts the address in the big type and the name above it small.
       That is a visual hierarchy, not a semantic one — the store NAME is what
       identifies this panel, so it is the heading and the dialog's label. */
    /* Three bands, because the old flat list gave a phone number, a distance
       and a star rating identical weight — actions and facts reading as one
       undifferentiated stack, with "See hours" orphaned under "Open now".
         1. actions  — what you came here to do; one gold primary, the rest quiet
         2. meta     — the at-a-glance facts, one line
         3. hours    — collapsed, because seven lines of times is reference
                       material, not something to scroll past every time */
    dbody.innerHTML =
      '<h3 class="kpsl-dname" id="kpsl-dtitle">' + esc(s.name || "Store") + "</h3>"
      + '<p class="kpsl-daddr">' + cityLine(s).map(esc).join("<br>") + "</p>"
      + '<div class="kpsl-acts" data-acts>'
        + '<a class="kpsl-cta" href="' + esc(directions(s)) + '" target="_blank" rel="noopener">'
        + icon("nav") + "Get directions</a>"
        + (s.phone
            ? '<a class="kpsl-chip" href="tel:' + esc(String(s.phone).replace(/[^0-9+]/g, "")) + '">'
              + icon("phone") + "Call</a>"
            : "")
      + "</div>"
      + '<ul class="kpsl-meta" data-meta>'
        + (s.miles != null ? "<li>" + esc(s.miles) + " mi away</li>" : "")
      + "</ul>"
      + '<div data-hours-slot></div>';

    /* The list payload is deliberately thin; hours, photos and the live
       open/closed check come from the per-store endpoint, which is the only
       thing that spends a Google lookup. */
    loadDetail(s, req, false);
  }

  /* `second` is the follow-up request. The first open of a store fires the
     vision pass server-side and returns before it finishes, so the photo order
     is Google's rather than ours — outside-first is not guaranteed until the
     pass has run. Rather than leaving the first visitor with the wrong photo
     leading, ask once more a few seconds later.
     Skipped if the shopper has already paged the carousel themselves: pulling
     the picture out from under someone who is looking at it is worse than a
     suboptimal order. */
  function loadDetail(s, req, second) {
    fetch(CFG.api + "/detail?id=" + encodeURIComponent(s.id), { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || req !== detailReq) return;
        if (second) { if (pi === 0) setPhotos(d.photos || [], d.shop || s); return; }
        hydrate(d, s);
        if (d.pendingJudgement && (d.photos || []).length > 1) {
          setTimeout(function () {
            if (req === detailReq && pi === 0) loadDetail(s, req, true);
          }, 4500);
        }
      })
      .catch(function () { /* the panel already shows everything the list knew */ });
  }

  function hydrate(d, s) {
    setPhotos(d.photos || [], d.shop || s);
    pinPreview(d.photos || [], s);
    var acts = dbody.querySelector("[data-acts]");
    var meta = dbody.querySelector("[data-meta]");
    var slot = dbody.querySelector("[data-hours-slot]");
    if (!acts || !meta || !slot) return;
    var shop = d.shop || {};

    /* The list payload may not have carried a phone; the detail lookup usually
       does. Add the Call action late rather than not at all. */
    if (!s.phone && shop.phone && !acts.querySelector('[href^="tel:"]')) {
      var call = document.createElement("a");
      call.className = "kpsl-chip";
      call.href = "tel:" + String(shop.phone).replace(/[^0-9+]/g, "");
      call.innerHTML = icon("phone") + "Call";
      acts.appendChild(call);
    }
    if (shop.website) {
      var wa = document.createElement("a");
      wa.className = "kpsl-chip";
      wa.href = shop.website;
      wa.target = "_blank"; wa.rel = "noopener nofollow";
      wa.innerHTML = icon("web") + "Website";
      acts.appendChild(wa);
    }
    /* Photos, reviews and anything else Google holds — on Google's page, at no
       cost to us. Added last so the primary action stays Get directions. */
    var gl = document.createElement("a");
    gl.className = "kpsl-chip";
    gl.href = googleListing(s, shop.placeId);
    gl.target = "_blank"; gl.rel = "noopener";
    gl.innerHTML = icon("star") + "Photos & reviews";
    acts.appendChild(gl);

    var open = shop.hours && shop.hours.openNow;
    if (open === true || open === false) {
      var st = document.createElement("li");
      st.className = open ? "kpsl-open" : "kpsl-shut";
      st.textContent = open ? "Open now" : "Closed now";
      meta.insertBefore(st, meta.firstChild);
    }
    if (shop.rating) {
      var rt = document.createElement("li");
      rt.innerHTML = '<span class="kpsl-star">' + icon("star") + "</span>" + shop.rating.toFixed(1)
        + (shop.reviewCount ? " (" + shop.reviewCount + ")" : "");
      meta.appendChild(rt);
    }

    /* Seven lines of opening times is reference material. Collapsed by default,
       and the summary line says the only part most people want. */
    if (shop.hours && shop.hours.weekdayDescriptions) {
      var wrap = document.createElement("div");
      wrap.className = "kpsl-hwrap";
      wrap.innerHTML =
        '<button class="kpsl-hbtn" type="button" aria-expanded="false">'
        + icon("clock") + "<span>Opening hours</span>"
        + '<svg class="kpsl-chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"'
        + ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
        + "</button>"
        + '<ul class="kpsl-hours" hidden>'
        + shop.hours.weekdayDescriptions.map(function (h) {
            var i = h.indexOf(":");
            return i < 0 ? "<li>" + esc(h) + "</li>"
              : "<li><span>" + esc(h.slice(0, i)) + "</span><span>" + esc(h.slice(i + 1).trim()) + "</span></li>";
          }).join("")
        + "</ul>";
      slot.appendChild(wrap);
      var btn = wrap.querySelector(".kpsl-hbtn"), ul = wrap.querySelector(".kpsl-hours");
      btn.addEventListener("click", function () {
        ul.hidden = !ul.hidden;
        btn.setAttribute("aria-expanded", String(!ul.hidden));
      });
    }

    /* Only ever shown when Google itself says the listing is gone. The row is
       still served rather than 404'd so a shared link explains itself. */
    if (shop.closed) {
      var n = document.createElement("p");
      n.className = "kpsl-closed";
      n.textContent = "Google reports this location as permanently closed. Call ahead before making the trip.";
      dbody.appendChild(n);
    }
  }

  /* A thumbnail on the selected pin, so the shop in the panel and the pin on
     the map are visibly the same place.
     Only the SELECTED store, and only from photos the detail panel has already
     fetched — every image shown costs a Places Photo call, so a thumbnail on
     all 60 list pins would multiply the bill by sixty for a glance. This one is
     free: same URL, already in the browser cache.
     Desktop only: on a phone the detail sheet covers the map entirely, so the
     popup would render behind it and never be seen. */
  function pinPreview(photos, s) {
    if (!map || !markers[selected]) return;
    if (window.matchMedia && !window.matchMedia("(min-width:901px)").matches) return;

    /* This used to bail when there was no photo, which meant it never ran at
       all: photos come from Places, Places is off, so every store had none and
       the popup Brandon was asking for already existed and had never once
       appeared. The card is now the point and the photo is the garnish --
       name, address and phone are on the store record and always present. */
    var shot = null;
    for (var i = 0; i < photos.length; i++) {
      if (photos[i].isStorefront) { shot = photos[i]; break; }
    }
    if (!shot) shot = photos[0];

    var img = "";
    if (shot) {
      var url = shot.url.charAt(0) === "/" ? API_ORIGIN + shot.url : shot.url;
      /* Ask for a small render — the popup is 150px wide and a 800px JPEG
         behind it is bytes nobody sees. */
      url = url.indexOf("?") > -1 ? url + "&w=300" : url + "?w=300";
      img = '<span class="kpsl-pop-img"><img alt="" src="' + esc(url) + '"></span>';
    }

    var addr = cityLine(s);
    var html = '<div class="kpsl-pop">'
      + img
      + '<span class="kpsl-pop-n">' + esc(s.name || "Store") + "</span>"
      + (addr.length ? '<span class="kpsl-pop-a">' + addr.map(esc).join("<br>") + "</span>" : "")
      + (s.phone ? '<a class="kpsl-pop-t" href="tel:'
          + esc(String(s.phone).replace(/[^0-9+]/g, "")) + '">' + esc(s.phone) + "</a>" : "")
      + (s.miles != null ? '<span class="kpsl-pop-m">' + esc(s.miles) + " mi away</span>" : "")
      + "</div>";

    markers[selected]
      .bindPopup(html, {
        className: "kpsl-popwrap",
        closeButton: false,
        offset: [0, -44],
        maxWidth: 170,
        autoPan: false,   /* panning here fights the setView the selection just did */
      })
      .openPopup();
  }

  function setPhotos(arr, shop) {
    photos = (arr || []).slice();
    /* Street View leads, when we have a key and coordinates. It is free,
       guaranteed to be the building, and it means the paid photos only have to
       cover the inside. */
    if (CFG.streetViewKey && shop && shop.lat != null && shop.lng != null) {
      photos.unshift({
        kind: "streetview",
        /* heading is the bearing from the PANORAMA to the store, precomputed
           per store from Street View's free metadata endpoint (see
           scripts/streetview-headings.mjs). Without it the Embed API faces due
           north, which puts the shop in frame only by luck -- the Milwaukee
           test case showed an empty alley at 0 and the actual storefront door
           at its computed 253.7.
           Omitted, not defaulted to 0, when we could not derive one: a store
           whose pano sits almost on top of it has no meaningful bearing, and
           Google's own default view beats a fabricated angle. */
        embed: "https://www.google.com/maps/embed/v1/streetview?key="
          + encodeURIComponent(CFG.streetViewKey)
          + "&location=" + shop.lat + "," + shop.lng
          + (shop.svHeading != null ? "&heading=" + shop.svHeading : "")
          + "&pitch=0&fov=90",
        isStorefront: true,
        showsKingPalm: false,
        attribution: null
      });
    }
    pi = 0;
    gal.dataset.empty = photos.length ? "0" : "1";
    gal.dataset.many = photos.length > 1 ? "1" : "0";
    noimg.hidden = photos.length > 0;
    photoEl.hidden = photos.length === 0;
    if (photos.length) showPhoto(0);
    else { shelf.hidden = true; credit.hidden = true; }
  }

  function showPhoto(i) {
    var p = photos[i];
    if (!p) return;
    pi = i;
    /* Two kinds of slide now: an <img> for a Places photo, an <iframe> for the
       Street View panorama. Only one is ever in the DOM. */
    var isSv = p.kind === "streetview";
    sv.hidden = !isSv;
    photoEl.hidden = isSv;
    if (isSv) {
      if (sv.getAttribute("src") !== p.embed) sv.setAttribute("src", p.embed);
      shelf.hidden = true;
      credit.hidden = false;
      credit.textContent = "Street View";
      var dh0 = "";
      for (var m = 0; m < photos.length; m++) dh0 += '<i class="' + (m === i ? "on" : "") + '"></i>';
      dots.innerHTML = dh0;
      gal.setAttribute("aria-label", "Street view, " + (i + 1) + " of " + photos.length);
      return;
    }
    gal.setAttribute("aria-label", "Photo " + (i + 1) + " of " + photos.length);
    var dh = "";
    for (var n = 0; n < photos.length; n++) dh += '<i class="' + (n === i ? "on" : "") + '"></i>';
    dots.innerHTML = dh;
    /* The photo endpoint redirects to Google's own CDN — we never hold the
       bytes, which is what Google's terms require. The API returns a
       root-relative path, which would resolve against kingpalm.com rather than
       the API host, so it is absolutised against CFG.api here. */
    photoEl.src = p.url.charAt(0) === "/" ? API_ORIGIN + p.url : p.url;
    photoEl.alt = (p.isStorefront ? "Storefront of " : "Inside ") + (currentName || "the store")
      + (p.showsKingPalm ? ", showing King Palm product" : "");
    shelf.hidden = !p.showsKingPalm;
    credit.hidden = !p.attribution;
    if (p.attribution) credit.textContent = "Photo: " + p.attribution;
  }

  function icon(kind) {
    var d = {
      pin: "M12 21s7-6.1 7-11a7 7 0 1 0-14 0c0 4.9 7 11 7 11z M12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
      phone: "M6.6 3h3l1.5 4-2 1.5a12 12 0 0 0 5.4 5.4l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16 16 0 0 1 4.6 5.2 2 2 0 0 1 6.6 3z",
      clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 7v5l3 2",
      web: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M3 12h18 M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z",
      star: "M12 4l2.4 5 5.6.8-4 3.9 1 5.5-5-2.6-5 2.6 1-5.5-4-3.9 5.6-.8z",
      nav: "M3 11l18-8-8 18-2-8-8-2z",
    }[kind];
    return '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
      + 'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="'
      + d + '"/></svg>';
  }

  function closeDetail(restoreFocus) {
    if (detail.dataset.open !== "1") return;
    detail.dataset.open = "0";
    detail.setAttribute("aria-hidden", "true");
    detailReq++;
    if (restoreFocus) {
      var card = list.querySelector('[data-i="' + selected + '"]');
      if (card) card.focus();
    }
  }

  /* ---- events ---------------------------------------------------------- */

  list.addEventListener("click", function (e) {
    var card = e.target.closest ? e.target.closest(".kpsl-card") : null;
    if (card) select(parseInt(card.dataset.i, 10), false);
  });
  backBtn.addEventListener("click", function () {
    closeDetail(true);
    if (map) map.closePopup();
    if (markers[selected]) markers[selected].setIcon(pin(selected, false, shops[selected] && shops[selected].stocksKingPalm));
  });
  $("[data-pprev]").addEventListener("click", function () { showPhoto((pi - 1 + photos.length) % photos.length); });
  $("[data-pnext]").addEventListener("click", function () { showPhoto((pi + 1) % photos.length); });
  root.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && detail.dataset.open === "1") closeDetail(true);
  });

  function search(params) {
    btn.disabled = true;
    list.innerHTML = '<p class="kpsl-msg">Searching…</p>';
    count.textContent = "";
    var url = CFG.api + "?scope=" + encodeURIComponent(CFG.scope)
      + "&radius=" + encodeURIComponent(radius.value) + "&limit=60&" + params;
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {
        list.innerHTML = '<p class="kpsl-msg">Could not load stores just now. Please try again.</p>';
      })
      .then(function () { btn.disabled = false; });
  }

  /* Locations by state. Loaded once, lazily, and only where it is shown —
     asking for it on a phone would spend a request on markup that is
     display:none. */
  function loadStates() {
    var wrap = root.querySelector("[data-states]");
    if (!wrap || wrap.dataset.done) return;
    if (!window.matchMedia || !window.matchMedia("(min-width:901px)").matches) return;
    wrap.dataset.done = "1";
    fetch(CFG.api + "/states", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.states || !d.states.length) return;
        wrap.hidden = false;
        wrap.querySelector("[data-states-sub]").textContent =
          d.total.toLocaleString() + " shops carrying King Palm across " + d.count + " states";

        function row(st) {
          return '<li><button class="kpsl-state" type="button" data-st="' + esc(st.code) + '">'
            + icon("pin")
            + '<span class="kpsl-state-n">' + esc(st.name) + "</span>"
            + '<span class="kpsl-state-c">' + st.shops.toLocaleString() + "</span>"
            + "</button></li>";
        }

        /* Top 12 up front, everything else one click away — NOT a cutoff.
           A threshold looks tidier and is the wrong trade: it hides the states
           where finding a stockist is already hardest, and someone in Vermont
           reads a missing row as "King Palm is not sold here" when there are 32
           shops. The 12 shown are ~60% of the whole network, so most people
           never open the rest. */
        var byCount = d.states.slice().sort(function (a, b) { return b.shops - a.shops; });
        var top = byCount.slice(0, 12).sort(function (a, b) { return a.name.localeCompare(b.name); });
        wrap.querySelector("[data-states-top]").innerHTML = top.map(row).join("");
        wrap.querySelector("[data-states-grid]").innerHTML = d.states.map(row).join("");
        wrap.querySelector("[data-states-more-l]").textContent = "All " + d.count + " states";

        var more = wrap.querySelector("[data-states-more]");
        var all = wrap.querySelector("[data-states-grid]");
        more.addEventListener("click", function () {
          all.hidden = !all.hidden;
          more.setAttribute("aria-expanded", String(!all.hidden));
          wrap.querySelector("[data-states-more-l]").textContent =
            all.hidden ? "All " + d.count + " states" : "Show fewer";
        });
      })
      .catch(function () { /* the locator works without an index */ });
  }

  root.addEventListener("click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-st]") : null;
    if (!b) return;
    /* Searching the state name rather than filtering client-side: the endpoint
       already geocodes free text, and this keeps one search path instead of
       two that can disagree. */
    input.value = b.querySelector(".kpsl-state-n").textContent;
    radius.value = "100";
    root.querySelector(".kpsl-shell").scrollIntoView({ behavior: "smooth", block: "start" });
    form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
  });

  /* Leaflet sizes its tile grid once and does not watch its own container, so
   * any change to the map's box leaves the grid stale -- visibly, ~10 tiles
   * covering a viewport that needs ~24, with grey where the map should be.
   *
   * This used to also maintain a --vw custom property for the full-bleed
   * breakout. It no longer does, and that is the fix rather than a
   * simplification: --vw could only ever be as fresh as its last measurement,
   * and the measurement it took at boot -- before the results made the page
   * tall enough to show a scrollbar -- was 15px too wide for the rest of the
   * page's life. Width now comes from the container, which is never stale. */
  function measure() {
    if (map) map.invalidateSize({ pan: false });
  }
  measure();

  var rt;
  var remeasure = function () { clearTimeout(rt); rt = setTimeout(measure, 120); };
  window.addEventListener("resize", remeasure);
  if (window.ResizeObserver) {
    new ResizeObserver(remeasure).observe(document.documentElement);
  } else {
    /* No observer: catch the two moments the page is known to grow. */
    setTimeout(measure, 600);
    setTimeout(measure, 2000);
  }

  /* Paint the map on load at a US-wide view. Waiting for the first search left
     a black rectangle filling two thirds of the section, which reads as broken
     rather than as empty. */
  initMap(39.5, -98.35, 4);
  loadStates();

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var q = String(input.value || "").trim();
    if (!q) return near.click();
    search("q=" + encodeURIComponent(q));
  });

  near.addEventListener("click", function () {
    if (!navigator.geolocation) return search("lat=" + CFG.fallback.lat + "&lng=" + CFG.fallback.lng);
    list.innerHTML = '<p class="kpsl-msg">Finding your location…</p>';
    navigator.geolocation.getCurrentPosition(
      function (p) { search("lat=" + p.coords.latitude + "&lng=" + p.coords.longitude); },
      function () {
        list.innerHTML = '<p class="kpsl-msg">Location unavailable — showing ' + CFG.fallback.label
          + ". Search a ZIP for your area.</p>";
        search("lat=" + CFG.fallback.lat + "&lng=" + CFG.fallback.lng);
      },
      { timeout: 8000, maximumAge: 300000 }
    );
  });
})();
